import React from 'react';
import { Box, TextField, MenuItem, InputAdornment, Typography } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';

const textFieldStyles = {
  '& .MuiOutlinedInput-root': {
    borderRadius: 1,
    fontSize: { xs: '0.675rem', sm: '0.875rem' },
    '& fieldset': {
      borderColor: '#e2e8f0',
    },
    '&:hover fieldset': {
      borderColor: '#cbd5e1',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#1f1f1f',
    },
  },
  '& .MuiInputLabel-root': {
    fontSize: { xs: '0.675rem', sm: '0.875rem' },
    color: '#737373',
    '&.Mui-focused': {
      color: '#1f1f1f',
    },
  },
};

const PRListFilters = ({
  filters,
  onFilterChange,
  projects,
  searchTerm,
  onSearchChange
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 2,
        mb: 1,
        alignItems: 'center',
        width: '100%'
      }}
    >
      {/* Project Filter */}
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1, minWidth: '25%' }}>
        <Typography
          variant="h6"
          sx={{
            color: '#737373',
            fontWeight: 500,
            fontSize: '0.875rem',
            lineHeight: '1.25rem',
          }}
        >
          Project
        </Typography>
        <TextField
          select
          value={filters.projectKey}
          onChange={(e) => onFilterChange('projectKey', e.target.value)}
          variant="outlined"
          size="small"
          sx={{
            width: '100%',
            ...textFieldStyles
          }}
          SelectProps={{
            MenuProps: {
              disableScrollLock: true,
              PaperProps: {
                style: {
                  maxHeight: 300,
                },
              },
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
              },
              transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
              },
            },
          }}
        >
          {projects.map((project) => {
            const proj = project.project || project;
            return (
              <MenuItem
                key={proj.api_key}
                value={proj.api_key}
                sx={{ fontSize: '0.9rem' }}
              >
                {proj.name || proj.repository_name || 'Unnamed Project'}
              </MenuItem>
            );
          })}
        </TextField>
      </Box>

      {/* Severity Filter */}
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1, minWidth: '25%' }}>
        <Typography
          variant="h6"
          sx={{
            color: '#737373',
            fontWeight: 500,
            fontSize: '0.875rem',
            lineHeight: '1.25rem',
          }}
        >
          Severity

        </Typography>
      <TextField
        select
        value={filters.severity}
        onChange={(e) => onFilterChange('severity', e.target.value)}
        variant="outlined"
        size="small"
        sx={{
          width: '100%',
          ...textFieldStyles
        }}
        SelectProps={{
          MenuProps: {
            disableScrollLock: true,
            PaperProps: {
              style: {
                maxHeight: 300,
              },
            },
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left',
            },
          },
        }}
      >
        <MenuItem value="all" sx={{ fontSize: '0.9rem' }}>All Severity</MenuItem>
        <MenuItem value="critical" sx={{ fontSize: '0.9rem' }}>Critical</MenuItem>
        <MenuItem value="medium" sx={{ fontSize: '0.9rem' }}>Medium</MenuItem>
        <MenuItem value="low" sx={{ fontSize: '0.9rem' }}>Low</MenuItem>
      </TextField>
      </Box>

      {/* Status Filter */}
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1, minWidth: '25%' }}>
        <Typography
          variant="h6"
          sx={{
            color: '#737373',
            fontWeight: 500,
            fontSize: '0.875rem',
            lineHeight: '1.25rem',
          }}
        >
          Status
        </Typography>
      <TextField
        select
        value={filters.status}
        onChange={(e) => onFilterChange('status', e.target.value)}
        variant="outlined"
        size="small"
        sx={{
          width: '100%',
          ...textFieldStyles
        }}
        SelectProps={{
          MenuProps: {
            disableScrollLock: true,
            PaperProps: {
              style: {
                maxHeight: 300,
              },
            },
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left',
            },
          },
        }}
      >
        <MenuItem value="all" sx={{ fontSize: '0.9rem' }}>All Status</MenuItem>
        <MenuItem value="open" sx={{ fontSize: '0.9rem' }}>Open</MenuItem>
        <MenuItem value="closed" sx={{ fontSize: '0.9rem' }}>Closed</MenuItem>
        <MenuItem value="merged" sx={{ fontSize: '0.9rem' }}>Merged</MenuItem>
      </TextField>
      </Box>

      {/* Search Field */}
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1, minWidth: '25%' }}>
        <Typography
          variant="h6"
          sx={{
            color: '#737373',
            fontWeight: 500,
            fontSize: '0.875rem',
            lineHeight: '1.25rem',
          }}
        >
          Search
        </Typography>
      <TextField
        placeholder="Search pull requests..."
        value={searchTerm}
        onChange={onSearchChange}
        variant="outlined"
        size="small"
        sx={{
          width: '100%',
          ...textFieldStyles,
          '& .MuiOutlinedInput-root': {
            borderRadius: 1,
            backgroundColor: '#fff',
            '& fieldset': {
              borderColor: '#e5e7eb',
            },
            '&:hover fieldset': {
              borderColor: '#d1d5db',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#1f1f1f',
            },
          },
          '& .MuiInputBase-input': {
            fontSize: '0.9rem',
            fontWeight: 500,
          }
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: '#6b7280', fontSize: '1.2rem' }} />
            </InputAdornment>
          ),
        }}
      />
      </Box>
    </Box>
  );
};

export default PRListFilters;